export enum FeatureEntitlements {
  SeoSelfServe = 'seo_self_serve',
}
